import { HttpClient } from '@angular/common/http';
import { Directive, inject } from '@angular/core';

@Directive()
export abstract class BaseApi {
  protected baseUrl: string;
  protected http: HttpClient = inject(HttpClient);
  protected xPaginationHeader = 'X-Pagination';

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }
}
